import React from "react";
import {
  ChevronDown,
  ChevronUp,
  HistoricalListContainer,
  MovementChevronContainer,
  MovementTitleContainer,
  MovimentItemCardBorder,
} from "../style";
import { TribunalIcon } from "@components/svgs";
import { Text, Button } from "nectar-ui";
import { LawsuitInfo } from "@customTypes/responses/lawsuit";
import { writeTitle } from "@pages/LawsuitPage/helper";
import HistoricalsStateManagement from "../HistoricalStateManagement/HistoricalStateManagement";
import { useInfiniteQuery } from "react-query";
import { LawsuitStatusBadge } from "@components/pages/lawsuit";
import { fetchLawsuitHistoricals } from "@services/lawsuit";
import { MoreButtonContainer } from "@pages/LawsuitListPage/style";

type LawsuitMovementItemProps = {
  lawsuit: LawsuitInfo;
  active?: boolean;
  icon?: boolean;
  hasMovements?: boolean;
};

const LawsuitMovementItem: React.FC<LawsuitMovementItemProps> = ({
  lawsuit,
  icon = false,
  hasMovements = false,
}) => {
  const isActive = lawsuit?.status.toUpperCase() === "ACTIVE";
  const [isOpen, setIsOpen] = React.useState(isActive);

  const lawsuitId = lawsuit?.id;

  const {
    data,
    isSuccess,
    isLoading,
    hasNextPage,
    fetchNextPage
  } = useInfiniteQuery({
    queryKey: ["getLawsuitHistoricals", lawsuitId],
    queryFn: ({pageParam = ""}) => fetchLawsuitHistoricals({ lawsuitId: lawsuit.id, cursor: pageParam }),
    keepPreviousData: true,
    enabled: isOpen,
    getNextPageParam: (lastPage) => {
      return lastPage.cursor === "" ? undefined : lastPage.cursor;
    },
  });

  const handleClick = () => {
    setIsOpen((current) => !current);
  };

  const handleFetchMore = () => {
    fetchNextPage();
  };

  return (
    <>
      <MovimentItemCardBorder border onClick={handleClick}>
        <MovementTitleContainer>
          {icon && <TribunalIcon style={{ scale: 1.3 }} />}
          <Text noMargin size="lg" semiBold>
            {writeTitle(lawsuit)}
          </Text>
          {isActive && <LawsuitStatusBadge status={lawsuit.status} />}
          <MovementChevronContainer>
            {isOpen ? <ChevronUp /> : <ChevronDown />}
          </MovementChevronContainer>
        </MovementTitleContainer>
      </MovimentItemCardBorder>
      <div style={{ minHeight: 10, display: "flex" }}>
        {hasMovements && <div className="rst__lineBlock rst__lineFullVerticalHalf" />}
        {isOpen && (
          <HistoricalListContainer>
            <HistoricalsStateManagement
              isLoading={isLoading}
              isSuccess={isSuccess}
              data={data}
            />
            {hasNextPage && (
              <MoreButtonContainer>
                <Button onClick={handleFetchMore} color="primary" reverse>
                  carregar mais andamentos
                </Button>
              </MoreButtonContainer>
            )}
          </HistoricalListContainer>
        )}
      </div>
    </>
  );
};

export default LawsuitMovementItem;
